<template>
  <v-dialog
    v-model="isDialogActive"
    max-width="800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
    @click:outside="close"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="!hideActivator" :loading="loading" v-bind="attrs" v-on="on" icon @click="openDialog">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span>{{ $t("components.thg.ThgQuoteDetailInformationStatusCard.title") }}</span>
        <v-spacer />
        <v-btn icon>
          <v-icon @click="close" color="grey lighten-1">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <debug>{{ thg }}</debug>
        <v-form ref="form" v-model="isValid">
          <v-autocomplete
            v-model="status"
            :items="items"
            :rules="requiredRule"
            :label="$t('components.thg.ThgQuoteDetailInformationStatusCard.status')"
            :hint="$t('components.thg.ThgQuoteDetailInformationStatusCard.statusHint')"
            persistent-hint
            required
            outlined
            solo
            data-test-status
          ></v-autocomplete>

          <v-checkbox
            v-model="userNotification"
            :label="$t('components.thg.ThgQuoteDetailInformationStatusCard.userNotification')"
            :hint="$t('components.thg.ThgQuoteDetailInformationStatusCard.userNotificationHint')"
            persistent-hint
          ></v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-text>
        <v-expansion-panels>
          <template v-for="(item, i) in helpItems">
            <v-expansion-panel :key="i">
              <v-expansion-panel-header>
                {{ item.title }}
                <template v-slot:actions>
                  <v-icon :color="item.color">
                    {{ item.icon }}
                  </v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                {{ $t(item.content) }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>
      </v-card-text>
      <v-card-actions>
        <v-btn class="ma-4" color="success" :disabled="!isValid" :loading="loading" @click="save">
          {{ $t("components.thg.ThgQuoteDetailInformationStatusCard.btnText") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { requiredRule } from "@/lib/rules/requiredRule";
import { IThg } from "@/models/thg.entity";
import { ThgStatusEnum } from "@/store/enum/thg/thg-status.enum";
import { Component, Prop, Vue } from "vue-property-decorator";
import Debug from "../utility/Debug.vue";

@Component({
  components: { Debug }
})
export default class ThgAdminUpdateStatusDialog extends Vue {
  @Prop()
  thg!: IThg;

  /**
   * Displays loading animation
   */
  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: false })
  hideActivator!: boolean;

  /**
   * The internal status
   */
  status = this.thg.status;

  /**
   * Notify the user about this change?
   */
  userNotification = true;

  /**
   * Form valid
   */
  isValid = false;

  /**
   * Show Dialog
   */
  isDialogActive = false;

  /**
   * All available status
   */
  items = Object.keys(ThgStatusEnum).map((k) => ThgStatusEnum[k as any]);

  helpItems = [
    {
      title: "Status Allgemein",
      content: "components.thg.ThgQuoteDetailInformationStatusCard.statusSuccess",
      icon: "mdi-check",
      color: "primary"
    },
    {
      title: "Error Status Allgemein",
      content: "components.thg.ThgQuoteDetailInformationStatusCard.statusError",
      icon: "mdi-close-outline",
      color: "error"
    },
    {
      title: "Error BEV",
      content: "components.thg.ThgQuoteDetailInformationStatusCard.statusErroBev",
      icon: "mdi-close-outline",
      color: "error"
    },
    {
      title: "Error Meter Reading",
      content: "components.thg.ThgQuoteDetailInformationStatusCard.statusErrorMeterReading",
      icon: "mdi-close-outline",
      color: "error"
    }
  ];

  openDialog() {
    this.isDialogActive = true;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  async save(): Promise<IThg> {
    this.isDialogActive = false;

    this.$emit("save", this.status, this.userNotification);
    this.close();

    this.thg.status = this.status;

    return this.thg;
  }

  async close() {
    this.isDialogActive = false;
    this.status = this.thg.status;
    this.$emit("refresh");
  }
}
</script>
